<script>
export default {
    data() {
        return {
            isDeleting: false,
        };
    },
    computed: {
        userEditData() {
            return this.$store.getters.USER_EDIT_DATA;
        },
        userId() {
            return this.userEditData?.id;
        },
        isDev() {
            return process.env.VUE_APP_VERSION === 'dev';
        },
    },
    methods: {
        initiateDelete() {
            if (!this.isDev || !this.userId) return;

            this.$store.commit('SHOP_POPUP_NAME', 'confirmed');
            this.$store.commit(
                'CONFIRMED_POPUP_METHOD',
                this.confirmDelete.bind(this)
            );
        },

        async confirmDelete() {
            if (this.isDeleting) return;

            this.isDeleting = true;

            try {
                const response = await this.$store.dispatch(
                    'hardDeleteUser',
                    this.userId
                );

                if (response && response.success) {
                    this.$store.commit('POPUP_ADD', {
                        title: 'USER PERMANENTLY DELETED',
                        description: [
                            `User ${response.user_email} has been permanently deleted.`,
                            `Total records removed: ${response.deleted_records_count}`,
                            `Deleted at: ${new Date(response.deleted_at).toLocaleString()}`,
                        ],
                        color: '#00d25b',
                    });
                }
            } catch (error) {
                this.$store.commit('POPUP_ADD', {
                    title: 'DELETION FAILED',
                    description: [error.message || 'Failed to delete user'],
                    color: '#ff4444',
                });
            } finally {
                this.isDeleting = false;
            }
        },
    },
};
</script>

<template>
    <div v-if="isDev" class="hard_delete_container">
        <div class="warning_banner">
            <p class="warning_text">
                <strong>⚠️ Danger Zone</strong>
                <br />
                Permanently delete this user and all related data. This action
                cannot be undone.
            </p>
        </div>

        <button
            class="hard_delete_button"
            :disabled="isDeleting || !userId"
            @click="initiateDelete"
        >
            <span v-if="!isDeleting">Permanently Delete User</span>
            <span v-else>Deleting...</span>
        </button>
    </div>
</template>

<style scoped>
.hard_delete_container {
    padding: 20px;
}

.warning_banner {
    background: #fff3cd;
    border: 2px solid #ffc107;
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 20px;
}

.warning_text {
    margin: 0;
    color: #856404;
    line-height: 1.5;
}

.hard_delete_button {
    width: 100%;
    padding: 15px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.hard_delete_button:hover:not(:disabled) {
    background: #c82333;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

.hard_delete_button:disabled {
    background: #e0e0e0;
    color: #999;
    cursor: not-allowed;
}
</style>
